<template>
	<div :key="key" class="d-flex relative">
		<v-overlay
			v-if="saving.poll"
			:value="true"
			absolute
			:dark="false"
			light
			color="white"
			opacity="0.8"
		>
			<v-progress-circular
				indeterminate
				size="50"
			></v-progress-circular>
		</v-overlay>
		<div class="d-flex flex-column w-100">
			<div class="bold">{{ poll.question }}</div>
				<div class="poll-answers-container w-100">
					<v-radio-group v-if="poll.type == 'single_choice'" v-model="fields.answers[0]" :disabled="revertEnabled || simple || !active" @change="vote()"  :key="key" class="flex-grow-1 ml-3 radio-disabled-unset">
						<template v-for="answer in sortedAnswers">
							<div class="mb-3" :key="answer.id">
								<v-radio class="mb-0" :value="answer.id" color="accent">
									<template v-slot:label>
										<span :class="['font-weight-bold grey--text', { 'text--darken-1' : answer.id === fields.answers[0] }]">{{ answer.answer }}</span>
									</template>
								</v-radio>
								<div v-if="voted || !active || isMyPoll" class="mt-2 d-flex">
									<div style="min-width: 300px">
										<div :class="['font-12 font-weight-bold grey--text', { 'text--lighten-5' : answer.id !== fields.answers[0] }]">
											{{ answer.percentage_value }}%
										</div>
										<div class="mt-4">
											<v-progress-linear :value="answer.percentage_value" :color="(answer.id === fields.answers[0]) ? 'accent' : 'grey lighten-3'" background-color="grey lighten-2"></v-progress-linear>
										</div>
									</div>
									<div class="ml-3">
										<div class="d-flex post-radio-avatar-container">
											<avatar v-for="user in answer.users" :key="'radio-avatar-' + user.id" class="d-flex"  xs :user="user"/>
											<v-avatar v-if="answer.users_answer_count >= 3" color="grey lighten-4" size="20">
												<v-icon class="font-14">mdi-dots-vertical</v-icon>
											</v-avatar>
											<div class="d-flex align-center font-12 ml-2 font-weight-bold grey--text text--darken-2" style="white-space: nowrap">
												{{ answer.users_answer_count }} głosów
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</v-radio-group>
				</div>
				<div v-if="!simple && !voted && poll.is_allowed_custom_answers && active" class="py-3">
					<!-- CUSTOM ANSWERS -->
					<v-btn v-if="poll.type == 'single_choice' && !fields.addCustom" depressed 
						@click="addCustomAnswer()">
						<v-icon>mdi-plus</v-icon>{{ this.$vuetify.lang.t('$vuetify.views.wall.poll.addCustomAnswer') }}
					</v-btn>
					<v-form v-if="fields.addCustom" ref="customAnswerForm" @submit.prevent="saveCustomAnswer()">
						<v-text-field  
							v-model="fields.customAnswer" 
							:loading="saving.customAnswer"
							:disabled="saving.customAnswer"
							:rules="[rules.required, rules.unique]"
							@keyup.enter="saveCustomAnswer()"
							placeholder="Treść odpowiedzi..."
							dense
							outlined
							:hide-details="false"
							required
							class="custom-answer-input"
							>
							<template slot="append">
								<v-btn v-if="fields.customAnswer" type="submit" depressed icon plain><v-icon>mdi-check</v-icon></v-btn>
								<v-btn @click="blockCustomAnswer()" depressed icon plain><v-icon>mdi-delete</v-icon></v-btn>
							</template>
						</v-text-field>	
					</v-form>
				</div>
				<div v-if="post.ended_at && active" class="d-flex flex-row">
					Czas trwania ankiety: <span class="bold ml-1">do {{ $moment(post.ended_at).format('LLL') }}</span>
				</div>
				<div v-if="!active" class="text-muted">
					<v-icon>mdi-information-outline</v-icon> Ankieta została zakończona
				</div>
			<div v-if="revertEnabled && !simple" class="d-flex flex-grow-1 align-end justify-end pb-3">
				<v-btn @click="revert()" elevation="0" small color="grey lighten-2" class="grey--text text--darken-3 py-4">
					<v-icon>$revert</v-icon> <span class="ml-1">{{ $vuetify.lang.t('$vuetify.views.wall.poll.revertVote') }}</span>
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
import axios from 'axios';
import _ from 'lodash';
import {mapGetters} from 'vuex';
// import axios from 'axios';
export default {
	name: "PostPoll",
	props: {
		post: {
			type: Object,
			required: true
		},
		simple: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Avatar
	},
	data () {
		return {
			fields: {
				answers: [],
				customAnswer: '',
				addCustom: false
			},
			saving: {
				poll: false,
				customAnswer: false
			},
			loading: false,
			answers: [],
			key: 0,
			rules: {
				required: value => !!value || this.$vuetify.lang.t('$vuetify.validation.required'),
				unique: value => {
					if(_.find(this.sortedAnswers, {answer: value})) {
						return this.$vuetify.lang.t('$vuetify.validation.unique');
					}
					return true;
				}
			}
			
		}
	},
	watch: {
		voted: function() {
			this.setMyAnswer();
		}
	},

	computed: {
		...mapGetters({
			user: 'auth/user'
		}),
		isMyPoll() {
			if(this.post.user.id == this.user.id) {
				return true;
			}
			return false;
		},
		poll() {
			return this.post.postable;
		},
		sortedAnswers() {
			if(this.voted) {
				return _.orderBy(this.poll.poll_answers, 'percentage_value', 'desc')
			}
			return _.orderBy(this.poll.poll_answers, 'order')
		},
		finalModel() {
			return this.poll.type == 'single_choice' ? {poll_answer_id: this.fields.answers[0]} : {poll_answer_id: this.fields.answers}
		},
		revertEnabled() {
			if(this.voted && this.active) {
				return true
			}
			return false;
		},
		active() {
			if(this.post.ended_at) {
				if(this.$moment() <= this.$moment(this.post.ended_at)) {
					return true;
				}
				return false;
			}
			return true;
		},
		voted() {
			if(this.poll.auth_user_answer_ids && this.poll.auth_user_answer_ids.length) {
				return true;
			}
			return false;
		}
	},
	methods: {
		setMyAnswer() {
			if(this.voted) {
				this.fields.answers = [this.poll.auth_user_answer_ids[0]]
			}	
			else {
				this.fields.answers = [];
			}
			
		},
		addCustomAnswer() {
			this.fields.addCustom = true;
			this.fields.customAnswer = '';
		},
		blockCustomAnswer() {
			this.fields.customAnswer = '';
			this.fields.addCustom = false;
		},
		async saveCustomAnswer() {
			// api/posts/poll/{post}/answer
			const valid = this.$refs.customAnswerForm.validate();
			if(valid) {
				this.saving.customAnswer = true;
				await axios.post(`posts/poll/${this.post.id}/answer`, {
					answer: this.fields.customAnswer
				})
				.then(response => {
					console.log("RESPONSE", response)
					this.$store.commit('wall/setPostPoll', response.data.data)
					this.blockCustomAnswer();
					this.setMyAnswer();
					this.key++;
				})
				.catch(error => {
					console.log("ERROR", error)
				})

				this.saving.customAnswer = false;
			}
			
		},
		async getAnswers() {
			// Load answears after voting from api
			this.loading = true;
			// Get from axios and fill data.answers
			// Set answer.percentage and answer.votes_count
			this.loading = false;
		},
		async revert() {
			// TODO: Revert in api
			
			this.saving.poll = true;
			await axios.delete(`posts/poll/vote/${this.fields.answers[0]}`)
				.then(response => {
					this.$store.commit('wall/setPostPoll', response.data.data)
					this.fields.answers = [];
					this.setMyAnswer();
					this.key++;
					
				})
				.catch(error => {
					console.log("DELETE ERROR", error.response)
				})
			this.saving.poll = false;
			
		},
		async vote() {
			if(!this.voted) {
				this.saving.poll = true;
				await axios.post(`posts/poll/${this.post.id}/vote`, this.finalModel)
					.then(response => {
						this.$store.commit('wall/setPostPoll', response.data.data)
						
						this.setMyAnswer();
						this.key++;
					})
					.catch(error => {
						console.log("VOTE ERROR", error.response)
					})
				this.saving.poll = false;
			}
		},

	},
	mounted() {
		this.setMyAnswer();
	}
	
}
</script>

<style lang="scss">
.theme--light.v-radio {
	&:hover {
		color: var(--v-grey-lighten1);
	}
}
.radio-disabled-unset .theme--light.v-radio--is-disabled .v-icon.mdi-radiobox-marked {
	&::before {
		color: var(--v-accent-base) !important;
	}
	
}
	.poll-answers-container {
		max-height: 50vh;
		overflow-y: auto;
		width: 100%;
	}
	.post-radio-avatar-container {
		.v-avatar {
			margin-left: -3px;
			outline: 2px solid var(--v-background-lighten1);
		}
	}
	.custom-answer-input {
		.v-input__append-inner {
			margin-top: 2px !important;
		}
		
	}
</style>
